import React from "react";

import Services from "../../../components/ServicesImgText";

import bore from "../../../images/services/ServicesPage/bore1.png";
const index = () => {
  return (
    <div>
      <Services
        title=">Re-Charge Bore-Well"
        heading="Re-Charge Bore-Well"
        text="Recharge home water bore or tube well with a natural source of rain. Get rid of the hassle of drying bore wells after a while and adopt a sustainable source of natural groundwater. Do it all in a very safe and transparent way at a low cost. Be completely safe from any kind of harmful health effects. "
        Image={bore}
      />
    </div>
  );
};

export default index;
